import { AfterViewInit, EventEmitter, Output } from '@angular/core';
import { Component, Input } from '@angular/core';
import { GeoLocationQualifierService } from 'src/app/model/api-services/qualifiers/geo-location-qualifier-service';

type AngleUnit = 'degs' | 'dms';

@Component({
  selector: 'app-angle-editor',
  templateUrl: './angle-editor.component.html',
  styleUrls: ['./angle-editor.component.scss']
})
export class AngleEditorComponent implements AfterViewInit {

  private _angle: number = 0;
  private editingDisplay = false;
  public angleDisplay = '';
  public angleUnit: AngleUnit = 'dms';
  @Input()
  set angle(value:number) {
    if(value === this._angle) return;
    this._angle = value;
    if (!this.editingDisplay) {
      this.UpdateAngleDisplay();
    }
    this.angleChange.emit(this._angle);
  }
  get angle():number {
    return this._angle;
  }
  @Output()
  angleChange = new EventEmitter<number>();

  @Input()
  bearing: number = 0;

  @Output()
  bearingChange = new EventEmitter<number>();


  @Input()
  direction:'from' | 'to' = 'to';
  constructor() { }

  ngAfterViewInit(): void {
    this.UpdateAngleDisplay();
  }

  AngleChanged() {
    this.angleChange.emit(this.angle);
  }
  HandleDisplayChange(value?: string) {
    this.editingDisplay = true;
    if (value !== undefined) {
      this.angleDisplay = value;
    }
    this.ApplyDisplayValue();
  }
  HandleDisplayKeyup() {
    this.editingDisplay = true;
    this.ApplyDisplayValue();
  }
  HandleDisplayBlur() {
    this.editingDisplay = false;
    this.ApplyDisplayValue();
    this.NormalizeDisplay();
  }
  private ApplyDisplayValue() {
    const parsed = this.angleUnit === 'dms'
      ? GeoLocationQualifierService.DegFromDMS(this.angleDisplay)
      : Number(this.angleDisplay);
    if ([undefined, null].indexOf(parsed as any) > -1 || isNaN(parsed)) {
      return;
    }
    this.angle = parsed;
  }
  HandleUnitChange() {
    this.editingDisplay = false;
    this.UpdateAngleDisplay();
  }
  NormalizeDisplay() {
    this.UpdateAngleDisplay();
  }
  private UpdateAngleDisplay() {
    this.angleDisplay = this.angleUnit === 'dms'
      ? GeoLocationQualifierService.ToDegMinSec(this._angle, 0, true)
      : GeoLocationQualifierService.ToDeg(this._angle, 2, true, true);
  }

}
